<template>
  <div class="container-wrapper" v-loading="loading">
    <div class="breadcrumb-wrapper">
      <span>资源位管理 / 操作</span>
      <el-button class="back" type="primary" @click="$router.go(-1)"
        >返回</el-button
      >
    </div>

    <div class="form-wrapper">
      <el-form
        class="advert-popup-form"
        label-width="120px"
        label-position="left"
        :model="formData"
        :rules="formRules"
        ref="formRef"
      >
        <el-form-item label="名称" prop="title">
          <el-input
            placeholder="请输入名称"
            v-model="formData.title"
            :disabled="!isOperable"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="有效时间">
          <el-date-picker
            style="width: 100%"
            type="datetimerange"
            start-placeholder="开始日期"
            range-separator="至"
            end-placeholder="结束日期"
            v-model="formData.daterange"
            :disabled="!isOperable"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="位置类型" prop="positionType">
          <el-select
            style="width: 100%"
            placeholder="请选择类型"
            v-model="formData.positionType"
            :disabled="!isOperable"
          >
            <el-option label="进展banner" :value="9"></el-option>
            <el-option label="首页活动信息栏" :value="13"></el-option>
            <el-option label="首页宣传栏" :value="14"></el-option>
            <el-option label="我的banner" :value="15"></el-option>
            <el-option label="排行榜banner" :value="19"></el-option>
            <el-option label="支付宝小程序首页banner" :value="21"></el-option>
            <el-option label="支付宝小程序我的banner" :value="22"></el-option>
            <el-option label="广场推荐banner" :value="23"></el-option>
            <el-option label="3.0.0版本之前的发现频道" :value="1"></el-option>
            <el-option label="跑步结束banner" :value="2"></el-option>
            <el-option label="运动音乐顶部" :value="3"></el-option>
            <el-option label="首页-为你推荐" :value="4"></el-option>
            <el-option label="社区-动态" :value="5"></el-option>
            <el-option label="3.0.0版本及之后的发现频道" :value="6"></el-option>
            <el-option label="问卷调查" :value="7"></el-option>
            <el-option label="运动banner" :value="8"></el-option>
            <el-option label="首页瓷片1" :value="10"></el-option>
            <el-option label="首页瓷片2" :value="11"></el-option>
            <el-option label="首页瓷片3" :value="12"></el-option>
            <el-option label="首页摩西" :value="20"></el-option>
            <el-option label="小程序顶部banner轮播" :value="16"></el-option>
            <el-option label="小程序banner" :value="17"></el-option>
            <el-option label="小程序底部banner列表" :value="18"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="排序"
          v-if="![10, 11, 12, 13, 14].includes(formData.positionType)"
        >
          <el-input-number
            v-model="formData.orderNum"
            :min="1"
            :max="5"
            :disabled="!isOperable"
          >
          </el-input-number>
        </el-form-item>
        <el-form-item
          label="图片"
          prop="bannerImage"
          v-if="formData.positionType"
        >
          <!-- <UploadImage
            :tips="uploadImgTips"
            :urls="formData.bannerImage"
            :readonly="!isOperable"
            @onUrls="imageUploaded"
          >
          </UploadImage> -->
          <SUpload
            actionUrl="/adminapi/v1/basicTools/upload/one?uploadImageType=8"
            v-model="formData.bannerImage"
            accept="image/*"
            type="drag"
            :size="[9, 8, 15, 2, 23].includes(formData.positionType) ? 300 : 0"
            :show-file-list="false"
          />
          <div class="supload-tips">
            {{ uploadImgTips }}
          </div>
        </el-form-item>
        <el-form-item label="点击资源" prop="type">
          <el-select
            style="width: 100%"
            placeholder="请选择点击资源"
            v-model="formData.type"
            :disabled="!isOperable"
          >
            <el-option label="无跳转" :value="-1"></el-option>
            <el-option label="跳转至已有文章" :value="1"></el-option>
            <el-option label="跳转至已有话题" :value="2"></el-option>
            <el-option label="跳转至URL" :value="5"></el-option>
            <el-option label="跳转至已有活动" :value="6"></el-option>
            <el-option label="跳转至微信小程序" :value="7"></el-option>
            <el-option label="跳转至音频" :value="8"></el-option>
            <el-option label="跳转至支付宝小程序" :value="9"></el-option>
            <el-option label="跳转至商城" :value="10"></el-option>
            <el-option label="跳转至兑吧" :value="11"></el-option>
            <el-option label="跳转至陆基金" :value="12"></el-option>
            <el-option label="跳转至摩西广告" :value="13"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          :label="formData.type === 1 ? '文章ID' : '话题ID'"
          v-if="[1, 2].includes(formData.type)"
          prop="targetId"
        >
          <el-input
            v-model="formData.targetId"
            :disabled="!isOperable"
          ></el-input>
        </el-form-item>

        <el-form-item
          :label="formData.type === 5 ? 'H5' : '活动链接'"
          v-if="[5, 6, 10, 11, 12, 13].includes(formData.type)"
          prop="targetUrl"
        >
          <el-input
            v-model="formData.targetUrl"
            :disabled="!isOperable"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="小程序原始ID"
          v-if="[7, 9].includes(formData.type)"
          prop="miniId"
        >
          <el-input
            v-model="formData.miniId"
            :disabled="!isOperable"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="小程序路径"
          v-if="[7, 9].includes(formData.type)"
          prop="miniPath"
        >
          <el-input
            v-model="formData.miniPath"
            :disabled="!isOperable"
          ></el-input>
        </el-form-item>

        <template v-if="formData.type === 8">
          <el-form-item label="专辑ID" prop="audioID">
            <el-input
              v-model="formData.audioID"
              :disabled="!isOperable"
            ></el-input>
          </el-form-item>
          <el-form-item label="主播名称" prop="audioNickName">
            <el-input
              v-model="formData.audioNickName"
              :disabled="!isOperable"
            ></el-input>
          </el-form-item>
          <el-form-item label="单曲数">
            <el-input-number
              v-model="formData.audioCount"
              :min="0"
              :disabled="!isOperable"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="是否付费">
            <el-radio-group
              v-model="formData.audioIsPaid"
              style="display: flex; line-height: 36px"
              :disabled="!isOperable"
            >
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </template>

        <el-form-item
          v-if="[5, 7, 9].includes(formData.type)"
          label="是否弹窗提示"
          required
          class="popup-prompt-form-item"
        >
          <div class="popup-prompt-row">
            {{ formData.isPopup }}
            <el-radio-group v-model="formData.isPopup" :disabled="!isOperable">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
            <el-input
              v-if="formData.isPopup === 1"
              v-model="formData.popupContent"
              maxlength="20"
              placeholder="请填写弹窗内容，最多20个字"
              :disabled="!isOperable"
              class="popup-prompt-input"
            />
            <div class="popup-prompt-example">
              <span class="popup-prompt-example-label">示例</span>
              <img :src="popupPromptExampleImg" alt="弹窗示例" />
            </div>
          </div>
        </el-form-item>

        <el-form-item label="学校">
          <el-radio-group
            style="display: flex; line-height: 36px"
            v-model="formData.applicableCampus"
            @change="changeCampus"
          >
            <el-radio :label="0" :disabled="!isOperable">全部</el-radio>
            <el-radio :label="1" :disabled="!isOperable">部分</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="平台">
          <el-radio-group
            style="display: flex; line-height: 36px"
            v-model="formData.platform"
          >
            <el-radio :label="-1" :disabled="!isOperable">全部</el-radio>
            <el-radio :label="0" :disabled="!isOperable">安卓</el-radio>
            <el-radio :label="1" :disabled="!isOperable">iOS</el-radio>
            <el-radio :label="2" :disabled="!isOperable">鸿蒙</el-radio>
            <!-- <el-radio :label="4" :disabled="!isOperable">小程序</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="formData.applicableCampus ? '应用学校' : '屏蔽学校'"
          :required="formData.applicableCampus ? true : false"
          prop="rootUnids"
        >
          <div style="display: flex; align-items: center">
            <el-select
              style="flex: 1; margin-right: 8px"
              placeholder="请选择学校"
              v-model="schoolData"
              filterable
              :disabled="!isOperable"
            >
              <el-option
                v-for="(item, index) in schoolDataSource"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button @click="clickAddSchools" :disabled="!isOperable"
              >添加</el-button
            >
          </div>
          <div class="card-wrap">
            <div
              v-for="item in formData.rootUnids"
              :key="item.value"
              class="card-item"
            >
              <span>{{ item.label }}</span>
              <el-button
                type="text"
                icon="circle-close"
                :disabled="!isOperable"
                @click="clickDeleteSchools(item.value)"
              >
              </el-button>
            </div>
          </div>
          <div class="card-footer">
            共计{{ formData.rootUnids.length }}所学校
          </div>
        </el-form-item>
        <el-form-item label="广告曝光代码">
          <el-input
            type="textarea"
            v-model="formData.adExposingCodes"
            :autosize="{ minRows: 5 }"
            :disabled="!isOperable"
          />
        </el-form-item>
      </el-form>
    </div>

    <div class="margin-20" v-if="isOperable">
      <el-button type="primary" @click="clickSave(1)">保存</el-button>
      <el-button type="primary" @click="clickSave(2)">保存并发布</el-button>
    </div>
  </div>
</template>

<script>
import UploadImage from "../../../../components/UploadItems/UploadImage.vue";
import popupPromptExampleImg from "../../../../assets/popup-prompt-example.png";

export default {
  components: {
    UploadImage,
  },

  data() {
    const validateSchool = (rule, value, callback) => {
      if (this.formData.applicableCampus && (!value || !value.length)) {
        return callback(new Error("学校不能为空"));
      }
      callback();
    };
    return {
      loading: false,
      isOperable: true, // 是否可操作
      id: "",
      hasQuery: false, // 是否有网络请求
      popupPromptExampleImg,
      formData: {
        title: "", // banner名称
        orderNum: 1,
        positionType: null,
        bannerImage: "",
        applicableCampus: 0,
        rootUnids: [],
        type: null,
        adExposingCodes: "",
        targetId: "",
        targetUrl: "",
        miniId: "", // 小程序ID
        miniPath: "", // 小程序路径
        audioID: "", // 专辑ID
        audioNickName: "", // 主播名称
        audioCount: 0, // 单曲数
        audioIsPaid: 0, // 是否付费
        daterange: [], // 日期
        isPopup: 0,
        popupContent: "",
        platform: undefined,
      },
      formRules: {
        title: { required: true, message: "请输入名称", trigger: "blur" },
        positionType: {
          type: "number",
          required: true,
          message: "请选择位置类型",
          trigger: "change",
        },
        bannerImage: {
          required: true,
          message: "请上传BANNER",
          trigger: "change",
        },
        type: {
          type: "number",
          required: true,
          message: "请选择方式",
          trigger: "change",
        },
        miniId: { required: true, message: "请输入小程序ID", trigger: "blur" },
        miniPath: {
          required: true,
          message: "请输入小程序路径",
          trigger: "blur",
        },
        targetId: { required: true, message: "请输入", trigger: "blur" },
        targetUrl: { required: true, message: "请输入", trigger: "blur" },
        audioID: { required: true, message: "请输入专辑ID", trigger: "blur" },
        audioNickName: {
          required: true,
          message: "请输入主播名称",
          trigger: "blur",
        },
        rootUnids: { validator: validateSchool, trigger: "change" },
      },
      schoolDataSource: [],
      schoolData: "",
    };
  },

  computed: {
    uploadImgTips() {
      const maps = {
        1: "建议：尺寸750 * 418，格式为jpg、png",
        2: "建议：尺寸370 * 77，大小≤300KB, 优先webp次选png",
        3: "建议：尺寸750 * 270，格式为jpg、png",
        4: "建议：尺寸584 * 240，格式为jpg、png",
        5: "建议：尺寸686 * 240，格式为jpg、png",
        6: "建议：尺寸686 * 240，格式为jpg、png",
        7: "建议：尺寸750 * 270，格式为jpg、png",
        8: "建议：尺寸370 * 77，大小≤300KB, 优先webp次选png",
        9: "建议：尺寸370 * 77，大小≤300KB, 优先webp次选png",
        10: "建议：尺寸398 * 158，格式为jpg、png",
        11: "建议：尺寸192 * 148，格式为jpg、png",
        12: "建议：尺寸192 * 148，格式为jpg、png",
        13: "建议：尺寸750 * 96，格式为jpg、png",
        14: "建议：尺寸686 * 40，格式为jpg、png",
        15: "建议：尺寸370 * 77，大小≤300KB, 优先webp次选png",
        23: "建议：尺寸370 * 180，大小≤300KB, 优先webp次选png",
      };
      try {
        return maps[this.formData.positionType];
      } catch (error) {
        return "";
      }
    },
  },

  mounted() {
    const queryInfo = this.$route.query;
    if (queryInfo.actionType === "detail") {
      this.isOperable = false;
    }
    if (queryInfo.id) {
      this.id = this.$route.query.id;
      this.queryDetailInfo();
    }
    if (queryInfo.positionType > 0) {
      this.formData.positionType = queryInfo.positionType;
    }
    this.queryALLSchool();
  },

  watch: {
    "formData.type"(val) {
      if (![5, 7, 9].includes(val)) {
        this.formData.isPopup = 0;
        this.formData.popupContent = "";
      }
    },
  },

  methods: {
    // 查询详情信息
    queryDetailInfo() {
      this.loading = true;
      this.$http({
        url: this.$util.domain + "/adminapi/v3/operate/banner/details",
        method: "POST",
        dataType: "json",
        body: JSON.stringify({ id: this.id }),
      })
        .then((res) => {
          if (res.body.data && JSON.stringify(res.body.data) !== "{}") {
            const data = res.body.data;
            let miniId = "";
            let miniPath = "";
            let audioID = "";
            let audioNickName = "";
            let audioCount = 0;
            let audioIsPaid = 0;
            if (data.type === 7) {
              miniId = this.handleUrlParam("id", data);
              miniPath = this.handleUrlParam("path", data);
            } else if (data.type === 8) {
              audioID = this.handleUrlParam("id", data);
              audioNickName = this.handleUrlParam("nickName", data);
              audioCount = this.handleUrlParam("count", data) * 1 || 0;
              audioIsPaid = this.handleUrlParam("isPaid", data) * 1 || 0;
            } else if (data.type === 9) {
              miniId = this.handleUrlParam("appId", data);
              miniPath = this.handleUrlParam("page", data);
            }
            this.formData = {
              title: data.title, // banner名称
              orderNum: data.orderNum || 1,
              positionType: data.positionType,
              bannerImage: data.imgUrl,
              applicableCampus: data.applicableCampus,
              rootUnids: data.campusList.map((item) => ({
                label: item.name,
                value: item.rootUnid,
              })),
              type: data.type,
              adExposingCodes: data.adExposingCodes,
              targetId: `${data.targetId}`,
              targetUrl: data.targetUrl,
              miniId, // 小程序ID
              miniPath, // 小程序路径
              audioID, // 专辑ID
              audioNickName, // 主播名称
              audioCount, // 单曲数
              audioIsPaid, // 是否付费
              daterange: [data.beginAt, data.endAt], // 日期
              platform: data.osType, // 平台
              isPopup: data.isPopup != null ? data.isPopup * 1 : 0,
              popupContent: data.popupContent || "",
            };
            this.hasQuery = true;
          }
        })
        .catch((error) => {
          this.$util.errorMsg("获取详情信息失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 查询全部学校
    queryALLSchool() {
      this.$http({
        url: this.$util.domain + "/adminapi/v1/basicTools/allSchools",
        method: "GET",
      })
        .then((res) => {
          if (res.body.data && res.body.data.length) {
            this.schoolDataSource = res.body.data.map((item) => ({
              label: item.name,
              value: item.rootUnid,
            }));
          } else {
            this.schoolDataSource = [];
          }
        })
        .catch((error) => {
          this.schoolDataSource = [];
        });
    },
    // 发送信息
    sendInfo(bannerStatus) {
      if ([5, 7, 9].includes(this.formData.type)) {
        if (this.formData.isPopup === 1 && !this.formData.popupContent.trim()) {
          this.$util.errorMsg("请填写弹窗内容");
          return;
        }
      }

      const {
        miniId,
        miniPath,
        audioID,
        audioNickName,
        audioCount,
        audioIsPaid,
        daterange,
        orderNum,
        isPopup,
        popupContent,
        ...param
      } = this.formData;

      let targetUrl = this.formData.targetUrl;
      let targetId = this.formData.targetId;
      let rootUnids = [];

      if ([1, 2].includes(this.formData.type)) {
        targetUrl = "";
      } else if ([5, 6].includes(this.formData.type)) {
        targetId = "";
      }
      if (this.formData.type === 7) {
        targetUrl = `id=${miniId.trim()}&path=${miniPath.trim()}`;
        targetId = "";
      } else if (this.formData.type === 8) {
        targetUrl = `id=${audioID.trim()}&nickName=${audioNickName.trim()}&count=${audioCount}&isPaid=${audioIsPaid}`;
        targetId = "";
      } else if (this.formData.type === 9) {
        targetUrl = `appId=${miniId.trim()}&page=${miniPath.trim()}`;
        targetId = "";
      }
      if (this.formData.rootUnids && this.formData.rootUnids.length) {
        rootUnids = this.formData.rootUnids.map((item) => item.value);
      }

      let params = {
        ...param,
        targetUrl,
        targetId,
        rootUnids,
        bannerStatus,
        isPopup: [5, 7, 9].includes(this.formData.type)
          ? this.formData.isPopup * 1
          : 0,
        popupContent:
          [5, 7, 9].includes(this.formData.type) && this.formData.isPopup === 1
            ? this.formData.popupContent.trim()
            : "",
        beginAt: daterange[0] ? new Date(daterange[0]).getTime() : "",
        endAt: daterange[1] ? new Date(daterange[1]).getTime() : "",
        osType: this.formData.platform,
      };
      if (![10, 11, 12, 13, 14].includes(this.formData.positionType)) {
        params["orderNum"] = orderNum;
      }
      if (this.id) {
        params["id"] = this.id;
      }
      this.loading = true;
      this.$http({
        url: this.$util.domain + "/adminapi/v3/operate/banner/add",
        method: "POST",
        dataType: "json",
        body: JSON.stringify({ ...params }),
      })
        .then((res) => {
          if (res.body.error === 10000) {
            this.$router.go(-1);
          } else {
            this.$util.errorMsg(res.body.message);
          }
        })
        .catch((err) => {
          this.$util.errorMsg(err.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 图片上传成功
    imageUploaded(img) {
      this.formData.bannerImage = img;
    },
    // 切换学校
    changeCampus() {
      if (this.hasQuery) {
        // 为了规避网络请求之后赋值applicableCampus时导致这个方法的调用
        this.hasQuery = false;
        return;
      }
      this.schoolData = null;
      this.formData.rootUnids = [];
    },
    // 点击添加学校
    clickAddSchools() {
      const datad = this.formData.rootUnids.find((item) => {
        return item.value === this.schoolData;
      });
      if (datad && JSON.stringify(datad) !== "{}") {
        this.schoolData = null;
        return;
      }
      const data = this.schoolDataSource.find((item) => {
        return item.value === this.schoolData;
      });
      if (data && JSON.stringify(data) !== "{}") {
        this.formData.rootUnids = [...this.formData.rootUnids, data];
        this.schoolData = "";
      }
    },
    // 点击删除学校
    clickDeleteSchools(unid) {
      const index = this.formData.rootUnids
        .map((item) => item.value)
        .indexOf(unid);
      this.formData.rootUnids.splice(index, 1);
    },
    clickSave(status) {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.sendInfo(status);
        }
      });
    },
    // 处理URl地址中的参数
    handleUrlParam(name, data) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = data.targetUrl.match(reg);
      if (r != null) {
        return r[2];
      }
      return null;
    },
  },
};
</script>

<style scoped>
.card-wrap {
  width: 100%;
  height: 200px;
  margin: 8px 0 4px;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #c0ccda;
  border-radius: 4px;
  overflow: auto;
  gap: 10px;
}

.card-footer {
  text-align: right;
  font-size: 14px;
  line-height: 1.5;
}

.card-item {
  display: inline-block;
  margin: 4px 4px;
  padding: 0px 4px;
  border: 1px solid #c0ccda;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// ResourceDetail.vue?5617f6a4